import { useLocation } from "react-router-dom";
import en from "./en";
import hi from "./hi";

const DICTS = { en, hi };

export const stripLang = (p) => (p === "/hi" ? "/" : p.startsWith("/hi/") ? p.slice(3) : p);
export const localize = (p, lang) => (lang === "hi" ? (p === "/" ? "/hi" : `/hi${p}`) : p);
export const langOf = (p) => (p === "/hi" || p.startsWith("/hi/") ? "hi" : "en");

export default function useT() {
  const { pathname } = useLocation();
  const lang = langOf(pathname);
  return { lang, t: DICTS[lang], lp: (p) => localize(p, lang) };
}
